import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import Typography from '../Typography';
import { useCategoryPageContext } from "../../contexts/app/CategoryPageContext";
import AxiosService from "../../services/axios.service";

function valuetext(value: number) {
  return `${value}°C`;
  //return `${parseFloat(value).toFixed(2)}°C`
}


export default function RangeSlider() {

  const { addFilter, filters, categoryId } = useCategoryPageContext()
  const [maxPrice, setMaxPrice] = React.useState(50)
  const [value, setValue] = React.useState<number[]>([filters?.price?.[0] || 0, filters?.price?.[1] || maxPrice])

  const handleChange = (event: Event, newValue: number | number[]) => {
    setValue(newValue as number[])
  }

  const handlePriceFilter = (event: Event, newValue: number | number[]) => {

    addFilter('price', value)

  }

  useEffect(() => {
    const getMaxPrice = async () => {
      //let maxPriceResponse = await AxiosService.get(`/categories/maximum-price/${categoryId}`);
      //setMaxPrice(Math.ceil(maxPriceResponse.data.max_price))

      AxiosService.get(`/categories/maximum-price/${categoryId}`).then(function (response) {
        setMaxPrice(Math.ceil(response.data.max_price))
        setValue([filters?.price?.[0] || 0, filters?.price?.[1] || Math.ceil(response.data.max_price)])

      })
        .catch(function (error) {
          //console.log(error);
        });
    };

    getMaxPrice(); // run it, run it
    return () => {
      // this now gets called when the component unmounts
    }
  }, [])


  return (
    <Box ml={1} sx={{ width: '95%' }}>
      <Slider
        getAriaLabel={() => 'Temperature range'}
        value={value}
        onChangeCommitted={handlePriceFilter}
        onChange={handleChange}
        valueLabelDisplay="auto"
        getAriaValueText={valuetext}
        sx={{ color: 'royalblue' }}
        min={0}
        step= {0.01}
        max={maxPrice}
      />

      <Typography align="center" color='white'>
        {/*{value[0]}€ - {value[1]}€*/}
        {parseFloat(value[0]).toFixed(2)}€ - {parseFloat(value[1]).toFixed(2)}€
      </Typography>
    </Box>
  );
}
